import { AppService } from "app/services/app.service";

import { ColetaDto } from "app/models/coleta-dto";
import { Observable } from "rxjs";

export abstract class AbSincronizar extends AppService {
  abstract prefixo: string;
  abstract getSincGeral(): Observable<any>;
  abstract getSincPorPerfilId(perfilId: number): Observable<any>;
  abstract getSincPorDispositivoId(dispositivoId: number): Observable<any>;
  abstract getSincPorUsuarioCredencialId(usuarioId: number): Observable<any>;
  abstract postColeta(coletaDTO: ColetaDto);
  abstract postColetaPanico(coletaDTO: ColetaDto);

}